export default __webpack_public_path__ + "static/media/devblog.94479247.png";